import { Component, OnInit, ViewChild } from "@angular/core";
import { IOption } from "ng-select";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { SafetyAlertModalComponent } from "../safety-alert-modal/safety-alert-modal.component";
import { HelperService } from "../services/helper.service";
import { RilrService } from "../services/rilr.service";
import { API_URL } from "../config";
import { ManagementOfChangeService } from "../services/management-of-change.service";
import { TosterMessageService } from "../services/toster-message.service";
//import { number } from "@amcharts/amcharts4/core";

@Component({
  selector: "app-report-rir-lahidh-welcomepage",
  templateUrl: "./report-rir-lahidh-welcomepage.component.html",
  styleUrls: ["./report-rir-lahidh-welcomepage.component.scss"],
  providers: [
    RilrService,
    HelperService,
    ManagementOfChangeService,
    TosterMessageService,
  ],
})
export class ReportRirLahidhWelcomePageComponent implements OnInit {
  public reportSystemID: number;
  public documentSystemID: number;
  public companySystemID = this.helperService.getSelectedCompanyId();

  safeUnsafeBehaviorArr: any = [
    { value: 1, label: "Safe" },
    { value: 0, label: "Unsafe" },
  ];

  behaviorCategoryArr: any = [
    { value: 1, label: "Line of Fire" },
    { value: 2, label: "Position of People" },
    { value: 3, label: "Hands & Fingers" },
    { value: 4, label: "Using Hand Rails" },
    { value: 5, label: "Using PPE" },
    { value: 6, label: "Manual Handling" },
    { value: 7, label: "Driving" },
    { value: 8, label: "Other" },
  ];

  solveArr: any = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  reportCategory: any = [
    { value: 1, label: "Near Miss" },
    { value: 2, label: "Hazard" },
    { value: 3, label: "Suggestion" },
    { value: 4, label: "Observation" },
  ];

  observationArr: any = [
    { value: 1, label: "Positive Quality Act / Condition" },
    { value: 2, label: "Quality at Risk / NC (Act)" },
    { value: 3, label: "Quality at Risk / NC (Condition)" },
  ];

  public companyArr: Array<IOption> = [];
  public countryArr: Array<IOption> = [];

  public segmentArr: Array<IOption> = [];
  public customerArr: Array<IOption> = [];
  public locationArr: Array<IOption> = [];

  public supervisorEmpList: Array<IOption> = [];

  @ViewChild("f") form: any;

  url: any;
  master: any = {
    // b01_segmentID: '',
    // c01_segmentID: '',
    // q01_segmentID: '',
    // b02_customerID: '',
    // c02_customerID: '',
    // q02_customerID: '',
    // b03_locationID: '',
    // c03_locationID: '',
    // q03_locationID: '',
  };

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private rilrService: RilrService,
    private managementOfChangeService: ManagementOfChangeService,
    private tosterMessageService: TosterMessageService
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.getFormData();
    setTimeout(() => {
      // this.getFormData();
    }, 0);
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  currentView: string = "welcome";

  switchView(view: string): void {
    this.currentView = view;
  }

  getFormData() {
    const that = this;
    that.rilrService
      .getLahidhFormData()
      .get({
        companySystemID: +that.helperService.getSelectedCompanyId(),
      })
      .subscribe(
        (data) => {
          var resp = data.data.data;
          //console.log(resp);
          that.segmentArr = that.helperService.setSelect2DropDownOptions(
            resp.segments,
            "id",
            "segment_code"
          );
          that.customerArr = that.helperService.setSelect2DropDownOptions(
            resp.customers,
            "customerID",
            "customerName"
          );
          that.locationArr = that.helperService.setSelect2DropDownOptions(
            resp.locations,
            "autoID",
            "description"
          );

          //   //console.log(that.segmentArr);
          //   //console.log(that.customerArr);
          //   //console.log(that.locationArr);
          that.spinner.hide();
          setTimeout(() => {
            that.spinner.hide();
          }, 0);
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  public typeHeadSupervisorB(value: any): void {
    const that = this;
    if (value.length > 2) {
      that.getSupervisorEmps(value);
    } else {
      that.supervisorEmpList = [];
    }
  }

  public getSupervisorEmps(value: any) {
    const that = this;
    that.managementOfChangeService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.supervisorEmpList = [];
          that.supervisorEmpList =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
        },
        (err) => {
          //console.log(err);
          that.supervisorEmpList = [];
        }
      );
  }

  public formCreate() {
    if (this.form.form.valid) {
      this.submitFormData();
    }
  }

  submitFormData() {
    this.spinner.show();
    const that = this;
    const tempArray = {};
    that.master.companySystemID = this.helperService.getSelectedCompanyId();
    tempArray["master"] = that.master;
    //console.log(tempArray);
    that.rilrService
      .submitLahidhFormData()
      .post(tempArray)
      .subscribe(
        (resp) => {
          that.master = {};
          this.spinner.hide();
          that.tosterMessageService.showSuccess(
            "Success",
            "Successfully form submitted!"
          );
          this.closeModal();
        },
        (error) => {
          this.spinner.hide();
          that.tosterMessageService.showError("Error", "Not submitted!");
          this.closeModal();
        }
      );
  }
}



// WEBPACK FOOTER //
// /app/src/app/report-rir-lahidh-welcomepage/report-rir-lahidh-welcomepage.component.ts